import React from 'react';

import AdditionalCoverage from '../../../components/fields/AdditionalCoverage';
import AmountLimit from '../../../components/fields/AmountLimit';
import AnnualIncrease from '../../../components/fields/AnnualIncrease';
import APIKey from '../../../components/fields/APIKey';
import CommisionCreditFields from '../../../components/fields/CommisionCreditFields';
import DealerFee from '../../../components/fields/DealerFee';
import DownPaymentFields from '../../../components/fields/DownPaymentFields';
import FileRate from '../../../components/fields/FileRate';
import FinancierProductName from '../../../components/fields/FinancierProductName';
import InterestRate from '../../../components/fields/InterestRate';
import PowerLimit from '../../../components/fields/PowerLimit';
import PPA from '../../../components/fields/PPA';
import SecretKey from '../../../components/fields/SecreKey';
import ShareSavings from '../../../components/fields/ShareSavings';
import TaxOnInterest from '../../../components/fields/TaxOnInterest';
import TypeProposalTemplate from '../../../components/fields/TypeProposalTemplate';

/**
 * Registro de campos reutilizables
 * Permite crear componentes de campos con las props necesarias
 */
export const createFieldRegistry = ({ control, disabled, setValue }) => ({
    additionalCoverage: (
        <AdditionalCoverage control={control} disabled={disabled} />
    ),
    amountLimit: (
        <AmountLimit
            control={control}
            disabled={disabled}
            setValue={setValue}
        />
    ),
    annualIncrease: (
        <AnnualIncrease
            control={control}
            disabled={disabled}
            setValue={setValue}
        />
    ),
    apiKey: <APIKey control={control} disabled={disabled} />,
    commissionCredit: (
        <CommisionCreditFields
            control={control}
            disabled={disabled}
            setValue={setValue}
        />
    ),
    dealerFee: (
        <DealerFee control={control} disabled={disabled} setValue={setValue} />
    ),
    downPayment: (
        <DownPaymentFields
            control={control}
            disabled={disabled}
            setValue={setValue}
        />
    ),
    fileRate: (
        <FileRate control={control} disabled={disabled} setValue={setValue} />
    ),
    financierProductName: (
        <FinancierProductName control={control} disabled={disabled} />
    ),
    interestRate: (
        <InterestRate
            control={control}
            disabled={disabled}
            setValue={setValue}
        />
    ),
    powerLimit: (
        <PowerLimit control={control} disabled={disabled} setValue={setValue} />
    ),
    ppa: <PPA control={control} disabled={disabled} setValue={setValue} />,
    secretKey: (
        <SecretKey control={control} disabled={disabled} setValue={setValue} />
    ),
    shareSavings: (
        <ShareSavings
            control={control}
            disabled={disabled}
            setValue={setValue}
        />
    ),
    taxOnInterest: (
        <TaxOnInterest
            control={control}
            disabled={disabled}
            setValue={setValue}
        />
    ),
    typeProposalTemplate: (
        <TypeProposalTemplate control={control} disabled={disabled} />
    ),
});

/**
 * Mapeos de campos predefinidos para algoritmos comunes
 */
export const createCommonFieldMappings = (fields) => ({
    static_payment: [
        fields.interestRate,
        fields.taxOnInterest,
        fields.additionalCoverage,
        fields.dealerFee,
        fields.commissionCredit,
        fields.downPayment,
    ],
    static_payment_tax: [
        fields.interestRate,
        fields.taxOnInterest,
        fields.additionalCoverage,
        fields.dealerFee,
        fields.annualIncrease,
        fields.commissionCredit,
        fields.downPayment,
    ],
    ppa_sunwise: [fields.ppa, fields.additionalCoverage, fields.annualIncrease],
    shared_savings: [
        fields.shareSavings,
        fields.additionalCoverage,
        fields.annualIncrease,
    ],
});
